import { useControlledOrUncontrolledState } from '@/hooks/useControlledOrUncontrolledState'
import { useEffect, useRef } from 'react'

export interface UseTabsProps {
  value?: string
  onChange?: (value: string) => void
  defaultValue?: string
}
export const useTabs = ({ value, defaultValue, onChange: onChangeProp }: UseTabsProps) => {
  const { isControlled, setUncontrolledState, state } = useControlledOrUncontrolledState({
    controlledState: value,
    defaultInternalState: defaultValue,
  })

  const onChange = (value: string) => {
    onChangeProp?.(value)
    if (isControlled) return
    setUncontrolledState(value)
  }

  const tabsRef = useRef<{ [key: string]: HTMLElement | null }>({})

  // Set the first tab as the default tab if no value or defaultValue is provided
  useEffect(() => {
    if (isControlled || state) return
    setUncontrolledState(Object.keys(tabsRef.current)[0])
  }, [isControlled, state, setUncontrolledState])

  const setTabRefs = (element: HTMLElement | null, value: string) => {
    tabsRef.current[value] = element
  }

  return {
    value: state,
    onChange,
    setTabRefs,
    tabsRef,
  }
}
